module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('cell', {
    attrs: {
      "value-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#4f5b77"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.cuIndex) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.choice.subjectName)
    }
  }), _vm._v(" "), _c('span', [(_vm.choice.score !== '' && _vm.choice.score !== undefined && _vm.choice.score !== 0) ? _c('span', {}, [_vm._v("(" + _vm._s(_vm.choice.score) + "分)")]) : _vm._e()])])])], 1), _vm._v(" "), _c('checklistspec', {
    ref: _vm.choice.id,
    attrs: {
      "max": 1,
      "options": _vm.options,
      "mchoice": true
    },
    on: {
      "on-change": _vm.toggleOption
    },
    model: {
      value: (_vm.anwser),
      callback: function($$v) {
        _vm.anwser = $$v
      },
      expression: "anwser"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-512de7ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/Choices/index.vue
// module id = amQG
// module chunks = 7